import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../layout/index.vue'
import lay from '../layout/ProjectLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('../views/Forget.vue')
  },
  {
     path: '/help',
    name: 'Help',
    component: () => import('../views/Help.vue')
  },
  {
    path: '/debug',
    name: 'Debug',
    component: () => import('../views/Debug.vue'),
    meta: {
      title: '调试工具',
      requireAuth: false
    }
  },
  {
    path: '/test-id-conversion',
    name: 'TestIdConversion',
    component: () => import('../views/TestIdConversion.vue'),
    meta: {
      title: 'ID转换测试',
      requireAuth: false
    }
  },
  {
    path: '/project-list',
    name: 'ProjectList',
    component: () => import('../views/project/ProjectList.vue'),
    meta: {
      title: '项目列表',
      requireAuth: true
    }
  },

  {
    path: '/system',
    component: Layout,
    redirect: '/system/total-list',
    children: [
      {
        path: 'total-list',
        name: 'TotalList',
        component: () => import('../views/total/TotalList.vue'),
        meta: {
          // title: '全化合物列表',
          requireAuth: true
        }
      },
      {
        path: 'compound-list',
        name: 'CompoundList',
        component: () => import('../views/compound/CompoundList.vue'),
        meta: {
          // title: '总物质列表',
          requireAuth: true
        },
        children: [
          {
            path: 'barium',
            name: 'Barium',
            component: () => import('../views/compound/Barium.vue'),
            meta: {
              // title: '白正',
              requireAuth: true
            }
          },
          {
            path: 'calcium',
            name: 'Calcium',
            component: () => import('../views/compound/Calcium.vue'),
            meta: {
              // title: '总物质列表',
              requireAuth: true
            }
          },
          {
            path: 'spironolactone',
            name: 'Spironolactone',
            component: () => import('../views/compound/Spironolactone.vue'),
            meta: {
              // title: '螺甲',
              requireAuth: true
            }
          },
          {
            path: 'amantadine',
            name: 'Amantadine',
            component: () => import('../views/compound/Amantadine.vue'),
            meta: {
              // title: '金刚子',
              requireAuth: true
            }
          },
          {
            path: 'ephedrine',
            name: 'Ephedrine',
            component: () => import('../views/compound/Ephedrine.vue'),
            meta: {
              // title: '辛夷',
              requireAuth: true
            }
          },
          {
            path: 'unfinished',
            name: 'Unfinished',
            component: () => import('../views/compound/Unfinished.vue'),
            meta: {
              // title: '未匹配化合物',
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'component-list',
        name: 'ComponentList',
        component: () => import('../views/component/ComponentList.vue'),
        meta: {
          // title: '成分列表',
          requireAuth: true
        },
        children: [
          {
            path: 'bari',
            name: 'Barium',
            component: () => import('../views/component/Barium.vue'),
            meta: {
              // title: '白正',
              requireAuth: true
            }
          },
          {
            path: 'cal',
            name: 'Calcium',
            component: () => import('../views/component/Calcium.vue'),
            meta: {
              // title: '总物质列表',
              requireAuth: true
            }
          },
          {
            path:'spiro',
            name: 'Spironolactone',
            component: () => import('../views/component/Spironolactone.vue'),
            meta: {
              // title: '螺甲',
              requireAuth: true
            }
          },
          {
            path: 'aman',
            name: 'Amantadine',
            component: () => import('../views/component/Amantadine.vue'),
            meta: {
              // title: '金刚子',
              requireAuth: true
            }
          },
          {
            path: 'ephe',
            name: 'Ephedrine',
            component: () => import('../views/component/Ephedrine.vue'),
            meta: {
              // title: '辛夷',
              requireAuth: true
            }
          },
          {
            path: 'unfin',
            name: 'Unfinished',
            component: () => import('../views/component/Unfinished.vue'),
            meta: {
              // title: '未匹配化合物',
              requireAuth: true
            }
          },
        ]

      },
      {
        path: 'input-list',
        name: 'InputList',
        component: () => import('../views/input/InputList.vue'),
        meta: {
          // title: '入靶列表',
          requireAuth: true
        },
        children: [
          {
            path: 'pre-register',
            name: 'PreRegister',
            component: () => import('../views/input/PreRegister.vue'),
            meta: {
              // title: '入血成分前处理',
              requireAuth: true
            }
          },
          {
            path: 'possible-input',
            name: 'PossibleInput',
            component: () => import('../views/input/PossibleInput.vue'),
            meta: {
              // title: '可能入血成分',
              requireAuth: true
            }
          },
          {
            path: 'substitute',
            name: 'Substitute',
            component: () => import('../views/input/Substitute.vue'),
            meta: {
              // title: '可能代谢物',
              requireAuth: true
            }
          },
          {
            path: 'substitute-pre-register',
            name: 'SubstitutePreRegister',
            component: () => import('../views/input/SubstitutePreRegister.vue'),
            meta: {
              // title: '可能代谢物前处理',
              requireAuth: true
            }
          },
          {
            path: 'drug-compound',
            name: 'DrugCompound',
            component: () => import('../views/input/DrugCompound.vue'),
            meta: {
              // title: '药物化合物',
              requireAuth: true
            }
          },
          {
            path: 'experimental-compound',
            name: 'ExperimentalCompound',
            component: () => import('../views/input/ExperimentalCompound.vue'),
            meta: {
              // title: '实验组化合物',
              requireAuth: true
            }
          },
          {
            path: 'test-compound',
            name: 'TestCompound',
            component: () => import('../views/input/TestCompound.vue'),
            meta: {
              // title: '入血成分',
              requireAuth: true
            }
          },
          {
            path: 'control-compound',
            name: 'ControlCompound',
            component: () => import('../views/input/ControlCompound.vue'),
            meta: {
              // title: '对照组化合物',
              requireAuth: true
            }
          }
        ]
      },
      {
        path: 'network',
        name: 'Network',
        component: () => import('../views/network/Network.vue'),
        meta: {
          title: '分子网络图',
          requireAuth: true
        },
        children: [
          {
            path: 'network1',
            name: 'Network1',
            component: () => import('../views/network/Network1.vue'),
            meta: {
              title: '正分子网络图',
              requireAuth: true
            }
          },
          {
            path: 'network2',
            name: 'Network2',
            component: () => import('../views/network/Network2.vue'),
            meta: {
              title: '负分子网络图',
              requireAuth: true
            }
          }
        ]
      }
    ]
  },

  {
    path: '/project',
    component: lay,
    redirect: '/project/compound-list',
    children: [
      {
        path: 'compound-list',
        name: 'CompoundList',
        component: () => import('../views/user/CompoundList.vue'),
        meta: {
          title: '项目列表',
          requireAuth: true
        },
        children: [
          {
            path: 'bar',
            name: 'Barium',
            component: () => import('../views/user/Barium.vue'),
            meta: {
              title: '项目列表',
              requireAuth: true
            }
          }
        ]
      },
     
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token')
//   if (to.meta.requireAuth) {
//     if (token) {
//       next()
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router